import React, { Component } from 'react';
import { consts, icons } from '../services/_consts';
import CvMakerContext from '../services/app-context';
import { Span, Span2, Div, H1, P, ImgUploder, Rating, Opts } from './elemans/_elemans'

export class Template2 extends Component {
    static contextType = CvMakerContext;
    constructor(props) {
        super(props);
        this.state = props.cv;
    }

    componentDidMount() {
        if (this.state.color2 == "#ffff00") {
            this.setState({ color2: this.defaultColor });
        }
    }
    defaultColor = '#157347';
    style = {
        section: {
            background: 'white',
            margin: '0 -12px',
            padding: '20px',
            borderBottom: '1px solid #198754'
        },
        sectionTitle: {
            borderBottom: '1px solid #198754',
            color: '#198754'
        },
        las: {
            margin: '0 4px',
            fontSize: '24px'
        }
    }


    remove = (field, i) => this.props.onRemoveFromList(field, i);

    up = (field, i) => this.props.onMoveInList(field, i, 'up');

    down = (field, i) => this.props.onMoveInList(field, i, 'down');

    render() {
        return (
            <div className='row mx-0 ps-0 pe-0' style={{ minHeight: '88vh', background: this.state.color2 + '22' }}>
                <div className={`col-4 px-0 text-white `} style={{ background: this.state.color2 }}>

                    <div className='text-center'>
                        {this.state.showAvatar && <>
                            <ImgUploder avatar={this.state.avatar}
                                maxSize="160000"
                                onChanged={f => { this.setState({ avatar: f }); this.props.handleChange('avatar', f); }}
                                style={{ minWidth: '200px', minHeight: '140px', border: '0px solid lightpink' }}
                            />
                        </>}
                        <div className="pt-4">
                            <h2 contentEditable="true" onBlur={e => this.props.onContentChanged(e, 'fullName')}>{this.state.fullName}</h2>
                            {this.state.showMySmallDesc && <Div onBlur={e => this.props.onContentChanged(e, 'mySmallDesc')} className='mb-4'>{this.state.mySmallDesc}</Div>}

                        </div>

                        <div className="text-start">
                            <div>
                                <Span2 showCondition={this.state.showBirthDate} className='text-warning' icon={icons.birthDate}
                                    onBlur={e => this.props.onContentChanged(e, 'birthDate')}
                                    onRemove={() => this.remove('showBirthDate')} >
                                    {this.state.birthDate}
                                </Span2>
                            </div>
                            <div><i className="las la-map-marker" style={this.style.las}></i><Span onBlur={e => this.props.onContentChanged(e, 'address')} className='text-warning'>{this.state.address}</Span></div>
                            <div>
                                <i className="las la-phone" style={this.style.las}></i>
                                <Span className='text-warning' onBlur={e => this.props.onContentChanged(e, 'tel')}>{this.state.tel}</Span>
                                <button onClick={() => this.remove('tel')} className="remove-btn">{consts.remove}</button>
                            </div>
                            <div>
                                <Span2 className='text-warning' icon={icons.at}
                                    onBlur={e => this.props.onContentChanged(e, 'email')}
                                    onRemove={() => this.remove('email')} >
                                    {this.state.email}
                                </Span2>
                            </div>

                            <div>
                                <Span2 showCondition={this.state.showSite} className='text-warning' icon={icons.link} 
                                    onBlur={e => this.props.onContentChanged(e, 'site')}
                                    onRemove={() => this.remove('showSite')} >
                                    {this.state.site}
                                </Span2>
                            </div>
                            <div>
                                <Span2 showCondition={this.state.showGithub} className='text-warning'  icon={icons.github}
                                    onBlur={e => this.props.onContentChanged(e, 'github')}
                                    onRemove={() => this.remove('showGithub')} >
                                    {this.state.github}
                                </Span2>
                            </div>

                            <div>
                                <Span2 showCondition={this.state.showLinkedIn} className='text-warning'  icon={icons.linkdIn}
                                    onBlur={e => this.props.onContentChanged(e, 'linkeIn')}
                                    onRemove={() => this.remove('showLinkedIn')} >
                                    {this.state.linkeIn}
                                </Span2>
                            </div>

                            <div>
                                <Span2 showCondition={this.state.showMarriage} className='text-warning'  icon={icons.marriage}
                                    onBlur={e => this.props.onContentChanged(e, 'marriage')}
                                    onRemove={() => this.remove('showMarriage')} >
                                    {this.state.marriage}
                                </Span2>
                            </div>


                            <div>
                                <Span2 showCondition={this.state.showMilitaryService} className='text-warning' icon={icons.militaryService}
                                    onBlur={e => this.props.onContentChanged(e, 'militaryService')}
                                    onRemove={() => this.remove('showMilitaryService')} >
                                    {this.state.militaryService}
                                </Span2>
                            </div>
                        </div>
                    </div>

                    <div className='mt-4 px-1 Skills'>
                        <div className=''>
                            <Span onBlur={e => this.props.onContentChanged(e, 'titleSkills')} className='h6 aviny'>{this.state.titleSkills}</Span>
                            <button onClick={() => { this.setState({ skills: [...this.state.skills, {}] }) }} className="add-btn noPrint">{consts.add}</button>
                        </div>
                        <div>
                            {this.state.skills.map((x, i) =>
                                <div className='bg-dark' style={{ margin: '2px' }} key={i} id={`skills${i}`} >
                                    <Rating
                                        rateOf10={x.rateOf10}
                                        showRating={this.state.showSkillRating}
                                        onBlur={e => this.props.onContentEditedInList(e, 'skills', i, 'title')}
                                        ocRatechange={(e, r) => this.props.onRatechange(e, 'skills', i, r)}
                                        retedcolor={this.state.color2}
                                    >{x.title}</Rating>
                                    {this.props.readonly ||
                                        <Opts i={i} length={this.state.skills.length}
                                            onUp={() => this.up('skills', i)}
                                            onDown={() => this.down('skills', i)}
                                            onRemove={() => this.remove('skills', i)}
                                        />}

                                </div>
                            )}
                        </div>
                    </div>

                    {this.state.languages.length > 0 &&
                        <div className='mt-4 px-1 Languages'>
                            <div className=''>
                                <Span onBlur={e => this.props.onContentChanged(e, 'titleLanguages')} className='h6 aviny'>{this.state.titleLanguages}</Span>
                                <button onClick={() => { this.setState({ languages: [...this.state.languages, {}] }) }} className="add-btn noPrint">{consts.add}</button>
                            </div>
                            <div>
                                {this.state.languages.map((x, i) =>
                                    <div className='bg-dark m-2' key={i} id={`languages${i}`} >
                                        <Rating
                                            rateOf10={x.rateOf10}
                                            showRating={this.state.showLanguageRatting}
                                            maxValue='5'
                                            onBlur={e => this.props.onContentEditedInList(e, 'languages', i, 'title')}
                                            ocRatechange={(e, r) => this.props.onRatechange(e, 'languages', i, r)}
                                        >{x.title}</Rating>
                                        {this.props.readonly ||
                                            <Opts i={i} length={this.state.languages.length}
                                                onUp={() => this.up('languages', i)}
                                                onDown={() => this.down('languages', i)}
                                                onRemove={() => this.remove('languages', i)}
                                            />}                                     </div>
                                )}
                            </div>
                        </div>
                    }
                </div>
                <div className='col-8' >
                    {this.state.showSummery &&
                        <div className='Summery mb-3 ' style={this.style.section}>
                            <div style={{ color: this.state.color2, borderBottom: `1px solid ${this.state.color2}` }}>
                                <Span onBlur={e => this.props.onContentChanged(e, 'titleSummery')} className='h6 aviny'>{this.state.titleSummery}</Span>
                            </div>
                            <p contenteditable="true" onBlur={e => this.props.onContentChanged(e, 'summery')}>{this.state.summery}</p>
                        </div>}

                    {this.state.educations.length > 0 &&
                        <div className='mb-3 Educations' style={this.style.section}>
                            <div style={{ color: this.state.color2, borderBottom: `1px solid ${this.state.color2}` }}>
                                <Span onBlur={e => this.props.onContentChanged(e, 'titleEducations')} className='h6 aviny'>{this.state.titleEducations}</Span>
                                <button onClick={() => { this.setState({ educations: [...this.state.educations, {}] }) }} className="add-btn noPrint">{consts.add}</button>
                            </div>
                            <div>
                                <ul>
                                    {this.state.educations.map((x, i) =>
                                        <li key={i} className="pt-2" id={`educations${i}`} >
                                            <span onBlur={e => this.props.onContentEditedInList(e, 'educations', i, 'level')} className='text-success pe-4' contenteditable="true">{x.level}</span>
                                            <span onBlur={e => this.props.onContentEditedInList(e, 'educations', i, 'year')} contenteditable="true">{x.year}</span> -
                                            <span onBlur={e => this.props.onContentEditedInList(e, 'educations', i, 'university')} contenteditable="true">{x.university}</span> –
                                            <span onBlur={e => this.props.onContentEditedInList(e, 'educations', i, 'city')} contenteditable="true">{x.city}</span> –
                                            <span onBlur={e => this.props.onContentEditedInList(e, 'educations', i, 'field')} contenteditable="true">{x.field}</span>
                                            {this.props.readonly ||
                                                <Opts i={i} length={this.state.educations.length}
                                                    onUp={() => this.up('educations', i)}
                                                    onDown={() => this.down('educations', i)}
                                                    onRemove={() => this.remove('educations', i)}
                                                />}
                                        </li>)}
                                </ul>
                            </div>
                        </div>
                    }

                    {this.state.workExperinces.length > 0 &&
                        <div className='WorkExperince mb-3' style={this.style.section}>
                            <div style={{ color: this.state.color2, borderBottom: `1px solid ${this.state.color2}` }}>
                                <Span onBlur={e => this.props.onContentChanged(e, 'titleWorkExperince')} className='h6 aviny'>{this.state.titleWorkExperince}</Span>
                                <button onClick={() => { this.setState({ workExperinces: [...this.state.workExperinces, {}] }) }} className="add-btn noPrint">{consts.add}</button>
                            </div>
                            <div>
                                <ul>
                                    {this.state.workExperinces.map((x, i) =>
                                        <li key={i} id={`workExperinces${i}`} >
                                            <span onBlur={e => this.props.onContentEditedInList(e, 'workExperinces', i, 'name')} className='text-success me-3' contenteditable="true">{x.name}</span>
                                            {this.props.readonly ||
                                                <Opts i={i} length={this.state.workExperinces.length}
                                                    onUp={() => this.up('workExperinces', i)}
                                                    onDown={() => this.down('workExperinces', i)}
                                                    onRemove={() => this.remove('workExperinces', i)}
                                                />}  
                                            <div className='text-gray me-3 float-end'>
                                                <Span onBlur={e => this.props.onContentEditedInList(e, 'workExperinces', i, 'from')} className='text-gray'>{x.from}</Span> -
                                                <Span onBlur={e => this.props.onContentEditedInList(e, 'workExperinces', i, 'until')} className='text-gray'>{x.until}</Span>
                                            </div>

                                            <div className='ms-4'>
                                                <span onBlur={e => this.props.onContentEditedInList(e, 'workExperinces', i, 'title')} contenteditable="true" style={{ fontWeight: 'bold' }}>{x.title}</span>
                                                <div onBlur={e => this.props.onContentEditedInList(e, 'workExperinces', i, 'desc')} contenteditable="true">{x.desc}</div>
                                            </div>
                                        </li>)}
                                </ul>
                            </div>
                        </div>
                    }

                    {this.state.freelanceProjects.length > 0 &&
                        <div className='mb-3 FreelanceProject' style={this.style.section}>
                            <div style={{ color: this.state.color2, borderBottom: `1px solid ${this.state.color2}` }}>
                                <Span onBlur={e => this.props.onContentChanged(e, 'titleFreelanceProjects')} className='h6 aviny'>{this.state.titleFreelanceProjects}</Span>
                                <button onClick={() => { this.setState({ freelanceProjects: [...this.state.freelanceProjects, {}] }) }} className="add-btn noPrint">{consts.add}</button>
                            </div>
                            <div>
                                <ul>
                                    {this.state.freelanceProjects.map((x, i) =>
                                        <li key={i} id={`freelanceProjects${i}`} >

                                            <span onBlur={e => this.props.onContentEditedInList(e, 'freelanceProjects', i, 'name')} className='text-success me-3' contenteditable="true">{x.name}</span>
                                            {this.props.readonly ||
                                                <Opts i={i} length={this.state.freelanceProjects.length}
                                                    onUp={() => this.up('freelanceProjects', i)}
                                                    onDown={() => this.down('freelanceProjects', i)}
                                                    onRemove={() => this.remove('freelanceProjects', i)}
                                                />} 
                                            <div className='ms-4'>
                                                <div onBlur={e => this.props.onContentEditedInList(e, 'freelanceProjects', i, 'desc')} contenteditable="true">{x.desc}</div>
                                            </div>
                                        </li>)}
                                </ul>
                            </div>
                        </div>
                    }

                    {this.state.certificates.length > 0 &&
                        <div className='Certificates' style={this.style.section}>
                            <div style={{ color: this.state.color2, borderBottom: `1px solid ${this.state.color2}` }}>
                                <Span onBlur={e => this.props.onContentChanged(e, 'titleCertificates')} className='h6 aviny'>{this.state.titleCertificates}</Span>
                                <button onClick={() => { this.setState({ certificates: [...this.state.certificates, {}] }) }} className="add-btn noPrint">{consts.add}</button>
                            </div>
                            <div>
                                <ul>
                                    {this.state.certificates.map((x, i) =>
                                        <li key={i} id={`certificates${i}`}>

                                            <span onBlur={e => this.props.onContentEditedInList(e, 'certificates', i, 'title')} className='text-success me-3' contenteditable="true">{x.title}</span>
                                            {this.props.readonly ||
                                                <Opts i={i} length={this.state.certificates.length}
                                                    onUp={() => this.up('certificates', i)}
                                                    onDown={() => this.down('certificates', i)}
                                                    onRemove={() => this.remove('certificates', i)}
                                                />} 
                                            <Span onBlur={e => this.props.onContentEditedInList(e, 'certificates', i, 'date')} className='text-gray me-3 float-end'>{x.date}</Span>
                                            <div className='ms-4'>
                                                <div onBlur={e => this.props.onContentEditedInList(e, 'certificates', i, 'desc')} contenteditable="true">{x.desc}</div>
                                            </div>
                                        </li>)}
                                </ul>
                            </div>
                        </div>
                    }

                </div>
            </div>
        );
    }
}
